import type { DefaultMessageKey, ExpertAssistMessage } from "../shared-types";

import { baseDefaultMessage, useTimelineStore } from "../state";

export const getDefaultMessage = (key: DefaultMessageKey) => {
    const defaultMessages = useTimelineStore.getState().defaultMessages;
    const defaultMessage = defaultMessages.find((message) => message.key === key) as unknown as ExpertAssistMessage;
    return { ...baseDefaultMessage, ...defaultMessage };
};
